exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon-container[data-v-765ad56d]{background:#fff;width:70px;border-style:solid;border-width:1px 0 1px 1px;border-color:#e3d4d4;display:flex}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-765ad56d","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/private/services/withdraw_steps/WithdrawStep1.vue
// module id = 974
// module chunks = 2